// 医保电子凭证激活——微信，主流程
const wxMainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `activation/wx/index${i + 1}`,
  name: `activationWxIndex${i + 1}`,
  component: () => import(`@/views/health/activation/wx/index${i + 1}.vue`)
}))

// 医保电子凭证激活——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `activation/zfb/index${i + 1}`,
  name: `activationZfbIndex${i + 1}`,
  component: () => import(`@/views/health/activation/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/health',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 医保电子凭证激活——微信，开始
    ...wxMainRoutes,

    // 医保电子凭证激活——支付宝，主流程
    ...zfbMainRoutes
  ]
}
